import { FC, useMemo } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import useAuth from "@hooks/useAuth";
import { useCorban } from "@hooks/useCorban";
import useFeatureFlags from "@hooks/useFeatureFlags";
import usePermissions from "@hooks/usePermissions";

import PageLoading from "../PageLoading";

export const PageGuard: FC = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { featureFlags } = useFeatureFlags();
  const { needCorbanSelection } = useCorban();
  const { homeRoute, isReady } = usePermissions();

  const paths = useMemo<string[]>(() => {
    const _paths = ["/"];
    if (featureFlags.enableResetPasswordV2) {
      _paths.push("/esqueci-senha", "/resetar-senha");
    }
    return _paths;
  }, [featureFlags]);

  if (paths.includes(location.pathname)) {
    if (!user) {
      return <Navigate replace to="/login" />;
    }

    if (isReady) {
      return <Navigate replace to={homeRoute} />;
    }

    if (needCorbanSelection) {
      return <Navigate replace to="/selecao-corban" />;
    }

    return <PageLoading />;
  }

  return <Outlet />;
};
